'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (props) {
  var data = Object.keys(props).filter(function (key) {
    return typeof props[key] !== 'function';
  }).reduce(function (obj, key) {
    return _extends({}, obj, _defineProperty({}, key, props[key]));
  }, {});

  var handlers = Object.keys(props).filter(function (key) {
    return typeof props[key] === 'function';
  }).reduce(function (obj, key) {
    return _extends({}, obj, _defineProperty({}, key, props[key]));
  }, {});

  return { data: data, handlers: handlers };
};